/**
 * Table column configuration for error logs
 */
export const LOGS_TABLE_COLUMNS = [
    { label: "SN", field: "id", sort: "disabled", width: '5%', rowNumber: true },
    { label: "Message", field: "msg", sort: "asc", width: '50%' },
    { label: "Stack", field: "stack", sort: "asc", width: '25%' },
    { label: "URL", field: "url", sort: "asc", width: '25%' },
    { label: "Date", field: "date", sort: "asc", width: '5%' },
];

/**
 * Table column configuration for usage charges
 */
export const USAGE_CHARGE_TABLE_COLUMNS = [
    { label: "SN", field: "id", sort: "disabled", width: '5%', rowNumber: true },
    { label: "Charge ID", field: "record_id", sort: "asc", width: '25%' },
    { label: "Amount", field: "amount", sort: "asc", width: '50%' },
    { label: "Store", field: "store", sort: "asc", width: '25%' },
    { label: "Type", field: "type", sort: "asc", width: '25%' },
    { label: "Date", field: "created_at", sort: "asc", width: '5%' },
];

/**
 * Table column configuration for Platform
 */
export const PLATFORM_TABLE_COLUMNS = [
    { label: "Platform Name", field: "name", sort: "asc", width: 150 },
    { label: "Email", field: "email", sort: "asc", width: 150 },
    { label: "Contact Name", field: "username", sort: "asc", width: 270 },
    { label: "Action", field: "action", sort: "disabled", width: 300 }
];

/**
 * Table column configuration for Store Handler (Auto BCL)
 */
export const STORE_HANDLER_TABLE_COLUMNS = [
    { label: "Name", field: "name", sort: "asc" },
    { label: "Coupert Links", field: "handle", sort: "asc" },
    { label: "Hotdeals Links", field: "hotdeals_handle", sort: "asc" },
    { label: "Domain URL", field: "domain", sort: "asc" },
    { label: "Others Links", field: "others_links", sort: "asc" },
    { label: "Shopify Domain", field: "store", sort: "asc" },
    { label: "Auto BCL", field: "status", sort: "asc", width: 150 },
    { label: "Action", field: "action", sort: "disabled" },
];

/**
 * Table column configuration for Scanner Website
 */
export const SCANNER_WEBSITE_TABLE_COLUMNS = [
    { label: "Name", field: "name", sort: "asc", width: 150 },
    { label: "Icon", field: "icon", sort: "asc", width: 150 },
    { label: "Contacts", field: "contacts", sort: "asc", width: 150 },
    { label: "Help", field: "help", sort: "asc", width: 150 },
    { label: "Website", field: "website", sort: "asc", width: 150 },
    { label: "Position", field: "position", sort: "asc", width: 150 },
    { label: "Status", field: "is_active", sort: "asc", width: 150 },
    { label: "Created At", field: "created_at", sort: "asc", width: 270 },
    { label: "Action", field: "action", sort: "asc", width: 200 }
];

/**
 * Table column configuration for Blocked Coupons
 */
export const BLOCKED_COUPON_TABLE_COLUMNS = [
    { label: "SN", field: "id", sort: "disabled", width: '5%', rowNumber: true },
    { label: "Name", field: "name", sort: "asc", width: '25%' },
    { label: "Source", field: "source", sort: "asc", width: '25%' },
    { label: "Status", field: "status", sort: "asc", width: '25%' },
    { label: "Leaked By", field: "leaked_by", sort: "asc", width: '25%' },
    { label: "Applicable To", field: "applicable_to", sort: "asc", width: '25%' },
    { label: "Is Customer Segment", field: "is_customer_segment", sort: "asc", width: '25%' },
    { label: "Action", field: "action", sort: "disabled", width: '25%' }
];

/**
 * Table column configuration for Reference Store
 */
export const REFERENCE_STORE_TABLE_COLUMNS = [
    { label: "ID", field: "id", sort: "asc", width: 150 },
    { label: "Parent Store", field: "p_store", sort: "asc", width: 150 },
    { label: "Child Store", field: "c_store", sort: "asc", width: 150 },
    { label: "Status", field: "is_active", sort: "asc", width: 150 },
    { label: "Created At", field: "created_at", sort: "asc", width: 270 },
    { label: "Updated At", field: "updated_at", sort: "asc", width: 200 },
    { label: "Action", field: "action", sort: "asc", width: 200 }
];

/**
 * Table column configuration for Dashboard Installed Stores
 */
export const DASHBOARD_INSTALLED_STORES_COLUMNS = [
    { label: "SN", field: "sn", sort: "asc", width: 50 },
    { label: "Name", field: "store_name", sort: "asc", width: 150 },
    { label: "Domain", field: "store_domain", sort: "asc", width: 150 },
    { label: "Plan", field: "plan", sort: "asc", width: 150 },
    { label: "Status", field: "status", width: 100 },
    { label: "Trial", field: "trial", width: 100 },
    { label: "Installed", field: "created", width: 100 },
];

/**
 * Table column configuration for Active Stores
 */
export const STORES_TABLE_COLUMNS = [
    { label: "SN", field: "sn", sort: "disabled", width: "5%", rowNumber: true },
    { label: "Name", field: "store_name", sort: "disabled", width: "10%" },
    { label: "Domain", field: "store_domain", sort: "asc", width: 120 },
    { label: "Plan", field: "plan", sort: "disabled", width: 250 },
    { label: "Recovered Revenue", field: "recovered_revenue", sort: "disabled", width: 200 },
    { label: "Installed", field: "created", sort: "asc", width: 100 },
    { label: "Webpixel", field: "is_set_webpixel", sort: "disabled", width: 100 },
    { label: "Details", field: "link", sort: "disabled", width: 150 },
    { label: "Coupon Scanner", field: "coupon_scanner", sort: "disabled", width: 150 },
];

/**
 * Table column configuration for Uninstalled Stores
 */
export const UNINSTALLED_STORES_TABLE_COLUMNS = [
    { label: "Store Name", field: "store_name", sort: "asc", width: 150 },
    { label: "Store Domain", field: "store_domain", sort: "asc", width: 150 },
    { label: "Details", field: "link", width: 150 },
    { label: "Transactions", field: "transactions", sort: "asc", width: 270 },
    { label: "Sales", field: "sales", sort: "asc", width: 200 },
    { label: "Discount", field: "discount", sort: "asc", width: 100 },
    { label: "Revenue", field: "revenue", sort: "asc", width: 150 },
    { label: "Installed", field: "created", sort: "asc", width: 100 },
    { label: "Script", field: "script", sort: "asc", width: 100 },
    { label: "Theme", field: "theme", sort: "asc", width: 100 },
];

/**
 * Table column configuration for Coupon Codes
 */
export const COUPON_CODES_TABLE_COLUMNS = [
    { label: "ID", field: "id", sort: "asc" },
    { label: "Coupon Code", field: "title", sort: "asc", width: 150 },
    { label: "Status", field: "status", sort: "asc", width: 270 },
    { label: "Action", field: "button", sort: "asc", width: 100 },
];

/**
 * Table column configuration for Blocked Orders
 */
export const BLOCKED_ORDERS_TABLE_COLUMNS = [
    { label: "Order", field: "order_no", sort: "asc" },
    { label: "Recovered Revenue", field: "recovered_revenue", sort: "asc" },
    { label: "Date", field: "created_at" },
    { label: "Order Total", field: "total", sort: "asc" },
    { label: "Applied Coupons", field: "applied_coupons", sort: "asc" },
    { label: "IsOnBCL", field: "is_on_bcl", sort: "asc" },
    { label: "Coupon", field: "coupon", sort: "asc" },
    { label: "Extensions", field: "extensions", sort: "asc" },
];

/**
 * Table column configuration for Blocked Orders
 */
export const LATEST_BLOCKED_ORDERS_TABLE_COLUMNS = [
    { label: "SN", field: "id", sort: "disabled", width: '5%', rowNumber: true },
    { label: "Store Name", field: "store_name", sort: "asc", width: '25%' },
    { label: "Store Type", field: "store_type", sort: "asc", width: '25%' },
    { label: "Last Blocked", field: "created_at", sort: "asc", width: '5%' },

    { label: "VeeperScript (H)", field: "veeper_headless", sort: "asc", width: '25%' },
    { label: "VeeperScript (N)", field: "veeper_normal", sort: "asc", width: '25%' },
    { label: "ListenerScript (H)", field: "listener_headless", sort: "asc", width: '25%' },
    { label: "ListenerScript (N)", field: "listener_normal", sort: "asc", width: '25%' },
    { label: "Web pixel", field: "webpixel", sort: "asc", width: '25%' },
    { label: "Checkout UI", field: "checkout", sort: "asc", width: '25%' },
    { label: "Domain", field: "store", sort: "asc", width: '25%' },
    { label: "Order No", field: "order_no", sort: "asc", width: '25%' },
    { label: "Webpixel ID", field: "webpixel_id", sort: "asc", width: '25%' },
];

/**
 * Toast notification messages
 */
export const MESSAGES = {
    LOGS_LOADED_SUCCESS: "Logs Loaded successfully",
    LOGS_CLEARED_SUCCESS: "Logs cleared successfully",
    LOGS_LOAD_ERROR: "Failed to load logs. Please check your network connection.",
    LOGS_CLEAR_ERROR: "Error clearing logs",
    USAGE_CHARGE_LOADED_SUCCESS: "Usages Charge is Loaded successfully",
    USAGE_CHARGE_LOAD_ERROR: "Failed to load usage charges",
    PLATFORM_LOADED_SUCCESS: "Platform List Loaded successfully",
    PLATFORM_CREATED_SUCCESS: "Platform Created successfully",
    PLATFORM_UPDATED_SUCCESS: "Platform Updated successfully",
    PLATFORM_DELETED_SUCCESS: "Platform Deleted successfully",
    PLATFORM_DELETION_FAILED: "Platform Deletion failed",
    PLATFORM_UPDATE_FAILED: "Platform Update failed",
    PLATFORM_CREATION_FAILED: "Platform Creation failed",
    STORE_HANDLER_LOADED_SUCCESS: "Auto BCL List Loaded successfully",
    STORE_HANDLER_CREATED_SUCCESS: "Auto BCL Created successfully",
    STORE_HANDLER_UPDATED_SUCCESS: "Auto BCL Updated successfully",
    STORE_HANDLER_DELETED_SUCCESS: "Auto BCL Deleted successfully",
    STORE_HANDLER_DELETION_FAILED: "Auto BCL Deletion failed",
    STORE_HANDLER_UPDATE_FAILED: "Auto BCL updated failed",
    STORE_HANDLER_CREATION_FAILED: "Auto BCL Creation failed",
    SCANNER_WEBSITE_LOADED_SUCCESS: "Scanner Website Loaded successfully",
    SCANNER_WEBSITE_CREATED_SUCCESS: "Scanner Website created successfully",
    SCANNER_WEBSITE_UPDATED_SUCCESS: "Scanner Website updated successfully",
    SCANNER_WEBSITE_CREATION_FAILED: "Scanner Website creation failed",
    SCANNER_WEBSITE_UPDATE_FAILED: "Scanner Website update failed",
    // Blocked Coupon messages
    BLOCKED_COUPON_LOAD_ERROR: "Failed to load blocked coupons",
    BLOCKED_COUPON_LOADED_SUCCESS: "Blocked coupons loaded successfully",
    BLOCKED_COUPON_ADDED_SUCCESS: "Blocked coupon has been added successfully",
    BLOCKED_COUPON_ADD_ERROR: "Failed to add blocked coupon",
    BLOCKED_COUPON_DELETED_SUCCESS: "Blocked coupon has been deleted successfully",
    BLOCKED_COUPON_DELETION_FAILED: "Blocked coupon could not delete!",
    COUPON_ELIGIBILITY_UPDATE_SUCCESS: "Coupon eligibility updated successfully",
    COUPON_ELIGIBILITY_UPDATE_FAILED: "Failed to update coupon eligibility",
    REFERENCE_STORE_LOADED_SUCCESS: "Reference store Loaded successfully",
    REFERENCE_STORE_CREATED_SUCCESS: "Reference store has created successfully",
    REFERENCE_STORE_UPDATED_SUCCESS: "Reference Store updated successfully",
    REFERENCE_STORE_DELETED_SUCCESS: "Reference store has deleted successfully",
    REFERENCE_STORE_LOAD_ERROR: "Failed to fetch data. Please check your network connection.",
    REFERENCE_STORE_CREATION_FAILED: "Reference store has created failed, Please check your network connection.",
    REFERENCE_STORE_UPDATE_FAILED: "Reference Store update failed, Please check your network connection.",
    REFERENCE_STORE_DELETION_FAILED: "Reference store has deleted failed, Please check your network connection.",
    DASHBOARD_LOADED_SUCCESS: "Dashboard Loaded successfully",
    DASHBOARD_LOAD_ERROR: "Please check your network connection.",
    STORES_LOADED_SUCCESS: "Stores Loaded successfully",
    STORES_LOAD_ERROR: "Failed to load stores. Please check your network connection.",
    UNINSTALLED_STORES_LOADED_SUCCESS: "Ex-Stores Loaded successfully",
    UNINSTALLED_STORES_LOAD_ERROR: "Failed to load ex-stores. Please check your network connection.",
    SHOPIFY_PLUS_UPDATED_SUCCESS: "Shopify Plus updated successfully",
    SHOPIFY_PLUS_UPDATE_FAILED: "Failed to update Shopify Plus status. Please check your network connection.",
    MERCHANT_INFO_LOAD_ERROR: "Failed to load merchant info",
    ORDERS_COUNT_LOAD_ERROR: "Failed to load orders count",
    MERCHANTS_DATA_LOAD_ERROR: "Failed to load merchants data",
    COUPON_CODES_LOAD_ERROR: "Failed to load coupon codes",
    COUPON_CODE_UPDATE_SUCCESS: "Coupon code updated successfully",
    COUPON_CODE_UPDATE_FAILED: "Failed to update coupon code status. Please check your network connection.",
    BLOCKED_ORDERS_LOAD_ERROR: "Failed to load blocked orders",
    PRODUCT_METAFIELD_UPDATE_SUCCESS: "Product metafield updated successfully",
    PRODUCT_METAFIELD_UPDATE_FAILED: "Failed to update product metafield. Please check your network connection.",
    COLLECTIONS_METAFIELD_UPDATE_SUCCESS: "Store collections metafield updated successfully",
    COLLECTIONS_METAFIELD_UPDATE_FAILED: "Failed to update store collections metafield. Please check your network connection.",
    // Campaign messages
    CAMPAIGN_CREATE_SUCCESS: "Campaigns created successfully",
    CAMPAIGN_CREATE_ERROR: "Failed to create campaigns",
    CAMPAIGN_LOAD_ERROR: "Failed to load campaigns",
    CAMPAIGN_LOAD_SUCCESS: "Campaigns loaded successfully",
    // Campaign Charge messages
    CAMPAIGN_CHARGE_UPDATE_SUCCESS: "Campaign Usage Charge has been updated successfully!",
    CAMPAIGN_CHARGE_UPDATE_FAILED: "Failed to update campaign charges",
    // Campaign Metafields messages
    CAMPAIGN_METAFIELDS_LOAD_ERROR: "Failed to load campaign metafields",
    CAMPAIGN_METAFIELDS_UPDATE_SUCCESS: "Metafields has been updated successfully!",
    CAMPAIGN_METAFIELDS_UPDATE_FAILED: "Failed to update campaign metafields",
    // Charge messages
    USAGE_CHARGE_UPDATE_SUCCESS: "Usage Charge has been updated successfully!",
    USAGE_CHARGE_UPDATE_FAILED: "Failed to update usage charges",
    // Common Settings messages
    COMMON_SETTINGS_UPDATE_SUCCESS: "Setting information has been updated successfully!",
    COMMON_SETTINGS_UPDATE_FAILED: "Failed to update common settings",
    // Discount Type messages
    DISCOUNT_TYPE_UPDATE_SUCCESS: "Discount Type Updated Successfully",
    DISCOUNT_TYPE_UPDATE_FAILED: "Failed to update discount type",
    // Placement Edit messages
    PLACEMENT_UPDATE_SUCCESS: "Placement has been updated successfully!",
    PLACEMENT_UPDATE_FAILED: "Failed to update placement",
    TOTAL_FEES_UPDATE_SUCCESS: "Total fees has been updated successfully!",
    TOTAL_FEES_UPDATE_FAILED: "Failed to update total fees",
    STORE_SETTINGS_UPDATE_SUCCESS: "Store settings has been updated successfully!",
    STORE_SETTINGS_UPDATE_FAILED: "Failed to update store settings",
    // Price Selector messages
    STORE_CREATED_DATE_UPDATE_SUCCESS: "Store info has been updated successfully!",
    STORE_CREATED_DATE_UPDATE_FAILED: "Failed to update store created date",
    // Plan Info messages
    MERCHANT_INFO_LOAD_SUCCESS: "Merchant info loaded successfully",
    SUBSCRIPTION_INFO_LOAD_ERROR: "Failed to load subscription info",
    TRIAL_DAYS_EXTEND_SUCCESS: "Trial days extended successfully",
    TRIAL_DAYS_EXTEND_FAILED: "Failed to extend trial days",
    USAGE_CHARGES_UPDATE_SUCCESS: "Usage charges updated successfully",
    SUBSCRIPTION_CANCEL_SUCCESS: "Subscription cancelled successfully",
    SUBSCRIPTION_CANCEL_FAILED: "Failed to cancel subscription",
    STORE_STATUS_UPDATE_SUCCESS: "Store status updated successfully",
    STORE_STATUS_UPDATE_FAILED: "Failed to update store status",
    // Store Handler messages (already has STORE_HANDLER_LOAD_ERROR covered by "Failed to load store handles")
    // Platform messages (PLATFORM_CREATION_FAILED and PLATFORM_UPDATE_FAILED already exist above)
    PLATFORM_LOAD_ERROR: "Failed to load platforms",
    PLATFORM_FETCH_TOKENS_ERROR: "Failed to fetch tokens",
    // Scanner Website messages (SCANNER_WEBSITE_CREATION_FAILED and SCANNER_WEBSITE_UPDATE_FAILED already exist above)
    SCANNER_WEBSITE_LOAD_ERROR: "Failed to load scanner websites",
    LATEST_BLOCKED_ORDERS_LOADED_SUCCESS: "Latest blocked orders loaded successfully",
    LATEST_BLOCKED_ORDERS_LOAD_ERROR: "Failed to load latest blocked orders",
    // Coupon Scanner messages
    COUPON_SCANNER_LOADED_SUCCESS: "Coupon Scanner loaded successfully",
    COUPON_SCANNER_LOAD_ERROR: "Failed to load coupon scanner data",
    COUPON_SCANNER_NO_DATA: "No coupon scanner data found",
    COUPON_SCANNER_UPDATED_SUCCESS: "Coupon scanner updated successfully",
    COUPON_SCANNER_UPDATE_FAILED: "Failed to update coupon scanner",
    COUPON_SCANNER_LINKS_GENERATED_SUCCESS: "Coupon scanner updated successfully",
    COUPON_SCANNER_LINKS_GENERATE_FAILED: "Error generating links",
    COUPON_SCANNER_LINKS_GENERATE_INVALID: "Please fill all the fields",
    STORE_HANDLE_LOAD_ERROR: "Failed to load store handle",
};